import script from "./itemV2PrintOut.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV2PrintOut.vue?vue&type=script&setup=true&lang=ts"

import "./itemV2PrintOut.vue?vue&type=style&index=0&id=06efc555&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06efc555"]])

export default __exports__